
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-guidelines-old",
      function () {
        return require("private-next-pages/user-guidelines-old.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user-guidelines-old"])
      });
    }
  